import validators from '../../utils/validators';

class CheckupPrescription {
  /**
   * @param data
   */
  constructor(data) {
    const properties = {
      id: (v) => validators.isNotEmptyString(v),
      user: (v) => validators.isNotEmptyString(v),
      item: (v) => validators.isObject(v),
      comment: (v) => validators.isNotEmptyStringOrNull(v),
      active: (v) => validators.isBoolean(v),
    };

    for (const property of Object.keys(properties)) {
      if (properties[property](data[property]) !== true) {
        throw new Error(`Invalid CheckupPrescription property '${property}' in ${data.id}`);
      }

      if (property === 'item') {
        this[property] = data[property].id;
      } else {
        this[property] = data[property];
      }
    }
  }
}

export default CheckupPrescription;
